import { useState } from 'react';
import { imageUrl } from '../../lib/format';
import { useSession } from '../../state/session';
import { Icon } from './Icon';
import styles from './ServerMark.module.css';

/**
 * The badge at the top of both navigation rails: the Discord server's own icon
 * when we have it, Spoyl's mark when we don't.
 *
 * Wearing the server's crest is what makes the activity feel like part of the
 * place rather than a guest inside it. It is deliberately a *fallback* chain
 * and not a requirement: the icon comes from the `guilds` scope, a player may
 * have refused it, a server may have no icon at all, and the CDN may fail from
 * inside the iframe — each of which lands on the mark instead of a hole.
 */
export function ServerMark({ size = 22 }: { size?: number }) {
  const { guild } = useSession();
  const [failed, setFailed] = useState(false);

  if (!guild?.iconUrl || failed) {
    return <Icon name="logo" size={size} />;
  }

  return (
    <img
      className={styles.icon}
      src={imageUrl(guild.iconUrl)}
      alt=""
      onError={() => setFailed(true)}
    />
  );
}
